import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('User', UserData);

    UserData.$inject = ['$translate', 'logger', 'CONF', 'KISS_USER', 'LegalEntityGroupUser', 'UserLevel'];

    /* @ngInject */
    function UserData($translate, logger, CONF, KISS_USER, LegalEntityGroupUser, UserLevel) {
        User.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getRoleLabel: getRoleLabel,
            getStatusLabel: getStatusLabel,
            isActive: isActive,
            isInactive: isInactive,
            isLocked: isLocked,
            isNotAccountant: isNotAccountant,
            isNotAdmin: isNotAdmin,
            getUserPicture: getUserPicture,
            getInfoForAutocompete: getInfoForAutocompete,
            getHigherBoRoles: getHigherBoRoles,
            isUserWrkFlowOnly: isUserWrkFlowOnly,
        };

        function User(userData) {
            if (!userData) {
                this.buildEmpty();
            } else {
                this.build(userData);
            }
        }

        return User;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.login = null;
            this.domain = null;
            this.newPassword = null;
            this.firstname = null;
            this.lastname = null;
            this.email = null;
            this.status = null;
            this.action = null;
            this.roles = null;
            this.hasPicture = null;
            this.newPictureId = null;
            this.job = null;
            this.phone = null;
            this.updateDate = null;
            this.language = null;
            this.lastConnectionDate = null;
            this.legalEntityGroupUsers = [];
            this.ownerEntityType = null;
        }

        function build(userData) {
            this.id = userData.id || null;
            this.login = userData.login || null;
            this.domain = userData.domain || null;
            this.newPassword = userData.newPassword || null;
            this.firstname = userData.firstname || null;
            this.lastname = userData.lastname || null;
            this.email = userData.email || null;
            this.status = userData.status || null;
            this.action = userData.action || null;
            this.roles = userData.roles || null;
            this.hasPicture = userData.hasPicture || null;
            this.newPictureId = userData.newPictureId || null;
            this.job = userData.job || null;
            this.phone = userData.phone || null;
            this.creationDate = userData.creationDate || null;
            this.updateDate = userData.updateDate || null;
            this.language = userData.language || null;
            this.lastConnectionDate = userData.lastConnectionDate || null;
            this.legalEntityGroupUsers = _.map(userData.legalEntityGroupUsers, lgu => new LegalEntityGroupUser(lgu));
            this.ownerEntityType = userData.ownerEntityType || null;
        }

        function getRoleLabel() {
            if (this.roles && angular.isArray(this.roles)) {
                return $translate.instant(
                    this.roles.indexOf('ACCOUNTANT') > -1 ? 'kiss_user.profil.accountant' : 'kiss_user.profil.executive'
                );
            }
            return '';
        }
        function getStatusLabel() {
            if (this.status) {
                return $translate.instant('kiss_user.status.' + angular.lowercase(this.status));
            }
            return '';
        }
        function isActive() {
            return this.status && this.status === KISS_USER.status[1];
        }
        function isInactive() {
            return this.status && this.status === KISS_USER.status[2];
        }
        function isLocked() {
            return this.status && this.status === KISS_USER.status[3];
        }

        function isNotAccountant() {
            var index = _.findIndex(this.roles, p => p === 'ACCOUNTANT');
            return index === -1;
        }
        function isNotAdmin() {
            var index = _.findIndex(this.roles, p => p === 'ADMIN_FO');
            return index === -1;
        }

        function isUserWrkFlowOnly() {
            return _.includes(this.roles, 'USER_WKF_ONLY');
        }

        function getUserPicture() {
            if (this.hasPicture) {
                return CONF.apiContext + '/api/v1/users/' + this.login + '/picture';
            }
            return CONF.apiContext + '/assets/images/photo.jpg';
        }

        function getInfoForAutocompete() {
            return this.firstname + ' ' + this.lastname + ' - (' + this.login + ')';
        }

        /**
         * Fournit le role le plus haut dans le cas d'un utilisateur back-office.
         */
        function getHigherBoRoles() {
            var result = new UserLevel({ level: 1, roles: ['USER-BO'] });
            if (this.roles) {
                this.roles.forEach(role => {
                    var roleFind = KISS_USER.boRoleByLevel.find(roleLvl => roleLvl.role === role);
                    if (roleFind) {
                        if (roleFind.level > result.level) {
                            result = new UserLevel();
                            result.level = roleFind.level;
                            result.roles = [roleFind.role];
                        } else if (roleFind.level === result.level) {
                            result.roles.push(roleFind.role);
                        }
                    }
                });
            }

            return result.roles;
        }
    }
})();
